var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "link", class: { "link--bordered": _vm.bordered } },
    [
      _c(
        "nuxt-link",
        { attrs: { to: _vm.url, target: _vm.target ? _vm.target : "" } },
        [_vm._v(_vm._s(_vm.title))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }